import { TransporterEnum } from '../enums/transporter.enum';
import { FirestoreDataConverter } from '@angular/fire/firestore';

/**
 * Model for Closing of day (Used for shipments)
 */
export class ClosingDay {
  id: string;
  date: string;
  site: string;
  transporter: TransporterEnum;
  documentHtml: string;
  documentPath: string;
  user: string;
  signature: string;

  constructor(closingDay?: Partial<ClosingDay>) {
    this.id = closingDay?.id ?? '';
    this.date = closingDay?.date ?? '';
    this.site = closingDay?.site ?? '';
    this.transporter = closingDay?.transporter ?? TransporterEnum.UNKNOWN;
    this.documentHtml = closingDay?.documentHtml ?? '';
    this.documentPath = closingDay?.documentPath ?? '';
    this.user = closingDay?.user ?? '';
    this.signature = closingDay?.signature ?? '';
  }

  /**
   * Converter used to convert a closing day from firebase
   */
  static converter: FirestoreDataConverter<ClosingDay> = {
    toFirestore: (closingDay: ClosingDay) => ({
      id: closingDay.id,
      date: closingDay.date,
      site: closingDay.site,
      transporter: closingDay.transporter,
      documentHtml: closingDay.documentHtml,
      documentPath: closingDay.documentPath,
      user: closingDay.user,
      signature: closingDay.signature,
    }),
    fromFirestore: (snapshot, options) => new ClosingDay({ ...snapshot.data(options), id: snapshot.id })
  };
}
